// -----------------------------------------------------------------------------------------------------------------------------------

// import {
//   React,
//   useCallback,
//   useContext,
//   useEffect,
//   useRef,
//   useState,
// } from "react";
// import moment from "moment-timezone";
// import "./BookAppointment.css";
// import BookAppImmi from "../../Component/BookAppointment/BookAppImmi";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import SelectTimeZone from "../../Component/Modal/SelectTimeZone";
// import BackPageBtn from "./BackPageBtn";
// import toast from "react-hot-toast";
// import HomeServices from "../../Services/HomeServices";
// import { Colorcontext } from "../../Component/context/ColorContext";
// import { validTimezones } from "./TimeZone";
// import { DateTime } from "luxon";
// import { fetchTimeByDate } from "../../utils/HttpClientXml";
// import Spinner from "./../../Spinner/Spinner";

// const PreferDateTime = () => {
//   const colordata = useContext(Colorcontext);

//   let newDate = new Date();
//   const formData = JSON.parse(localStorage.getItem("formData"));
//   const [TorontoTimeZone, setTorontoTimeZone] = useState("America/Toronto");
//   const currentDateTimeToronto = moment.tz(TorontoTimeZone);
//   const [timeBlock, setTimeBlock] = useState(false);
//   const myTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

//   const [searchSlotsForNextPageObject, setSearchSlotsForNextPageObject] =
//     useState({});

//   const [fetchTimeLoading, setFetchTimeLoading] = useState(false);

//   const dateTimeField = {
//     date: "",
//     time: "",
//     value: formData,
//   };

//   const [viewBlockdate, setViewBlockdate] = useState([]);
//   const [allTime, setAllTime] = useState([]);
//   const [dateTime, setDateTime] = useState(dateTimeField);
//   const [modalA, setModalA] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [onChangeDate, setOnChangeDate] = useState("");

//   const location = useLocation();
//   const navigate = useNavigate();

//   const tileClassName = ({ date, view }) => {
//     if (
//       selectedDate &&
//       date.getDate() === selectedDate.getDate() &&
//       date.getMonth() === selectedDate.getMonth() &&
//       date.getFullYear() === selectedDate.getFullYear()
//     ) {
//       return "active-date";
//     }
//     if (
//       view === "month" &&
//       date.getDate() === new Date().getDate() &&
//       date.getMonth() === new Date().getMonth() &&
//       date.getFullYear() === new Date().getFullYear()
//     ) {
//       return "current-date";
//     }
//     return null;
//   };

//   const isFirstRender = useRef(true);

//   useEffect(() => {
//     if (isFirstRender.current) {
//       isFirstRender.current = false;
//       return;
//     }

//     GetAllDate(moment().tz(TorontoTimeZone).format("YYYY-MM-DD"));
//     fetchViewBlockDate();
//   }, [TorontoTimeZone, onChangeDate]);

//   const GetAllDate = async (date) => {
//     const date1 = new Date(onChangeDate);

//     const year = date1.getFullYear();
//     const month = String(date1.getMonth() + 1).padStart(2, "0");
//     const day = String(date1.getDate()).padStart(2, "0");

//     const formattedDate = `${year}-${month}-${day}`;

//     let data = {
//       booking_serviceType_id: location?.state?._id,
//       date: formattedDate,
//       timezone: TorontoTimeZone,
//     };

//     setSearchSlotsForNextPageObject({ ...data });

//     setFetchTimeLoading(true);

//     const startTime = Date.now();

//     try {
//       const res = await fetchTimeByDate(data);

//       const elapsedTime = Date.now() - startTime;
//       const remainingTime = 3000 - elapsedTime;

//       if (res && res.status) {
//         console.log("Amit All Time", res?.data);
//         setAllTime(res?.data);
//         setTimeBlock(res?.allTimeBlock);
//       }

//       if (remainingTime > 0) {
//         setTimeout(() => {
//           setFetchTimeLoading(false);
//         }, remainingTime);
//       } else {
//         setFetchTimeLoading(false);
//       }
//     } catch (error) {
//       console.error("⛔ API failed:", error);

//       const elapsedTime = Date.now() - startTime;
//       const remainingTime = 3000 - elapsedTime;

//       if (remainingTime > 0) {
//         setTimeout(() => {
//           setFetchTimeLoading(false);
//         }, remainingTime);
//       } else {
//         setFetchTimeLoading(false);
//       }
//     }
//   };

//   const fetchViewBlockDate = async () => {
//     const res = await HomeServices.viewBlockDate();
//     if (res && res?.status) {
//       setViewBlockdate(res?.data);
//     }
//   };

//   const blockDate = (date) => {
//     const formatdate = moment(date).tz(TorontoTimeZone).format("YYYY-MM-DD");
//     const check = viewBlockdate.find((item) => item?.block_date === formatdate);
//     if (check) {
//       return false;
//     } else {
//       return false;
//     }
//   };

//   const handleDateChange = async (date) => {
//     setTorontoTimeZone("America/Toronto");
//     const date1 = new Date(date);
//     const year = date1.getFullYear();
//     const month = String(date1.getMonth() + 1).padStart(2, "0");
//     const day = String(date1.getDate()).padStart(2, "0");

//     const formattedDate = `${year}-${month}-${day}`;

//     console.log("YTR117", formattedDate, date, TorontoTimeZone);

//     const chDate = moment(date).format("ddd, MMM D, YYYY");
//     setOnChangeDate(chDate);

//     setDateTime({
//       ...dateTime,
//       date: date,
//       time: "",
//     });

//     setSelectedDate(date);
//   };

//   const tileDisabled = ({ date }) => {
//     let todayDay = moment(newDate).tz(TorontoTimeZone).format("YYYYMMDD");
//     let selectedDate = moment(date).format("YYYYMMDD");

//     const currentDate = new Date(
//       moment(newDate).tz(TorontoTimeZone).format("YYYY-MM-DD")
//     );
//     currentDate.setHours(0, 0, 0, 0);
//     const isPastDate = todayDay > selectedDate;

//     const fourteenDaysAhead = new Date();
//     fourteenDaysAhead.setDate(currentDate.getDate() + 14);
//     fourteenDaysAhead.setHours(0, 0, 0, 0);
//     const isDateBeyondFourteenDays = date > fourteenDaysAhead;

//     const isSunday = date.getDay() === 0;

//     const isBlocked = blockDate(date);

//     return isPastDate || isDateBeyondFourteenDays || isSunday || isBlocked;
//   };

//   const onSUbmit = () => {
//     if (
//       moment(dateTime.date).format("YYYYMMDD") >=
//       moment(new Date()).format("YYYYMMDD")
//     ) {
//       if (dateTime.date && dateTime.time) {
//         if (typeof dateTime.time === "string") {
//           const fullDateTime = new Date(dateTime.date);
//           const [hours, minutes] = dateTime.time.split(":");
//           fullDateTime.setHours(parseInt(hours), parseInt(minutes));

//           navigate("/joinwaitlist", {
//             state: {
//               dateTime: dateTime,
//               searchSlotsForNextPageObject: searchSlotsForNextPageObject,
//             },
//           });
//         } else {
//           toast.error("Invalid time format");
//         }
//       } else {
//         toast.error("Please Select the Date and Time");
//       }
//     }
//   };

//   // Modified function: Only show slot if ALL three parameters are false
//   const isSlotAvailable = (item) => {
//     return !item.isBooked && !item.isTimeOver && !item.isBlockedTime;
//   };

//   // Function to check if slot is blocked/selected for styling
//   const isSlotBlocked = (item) => {
//     return item.isBooked || item.isTimeOver || item.isBlockedTime;
//   };

//   useEffect(() => {
//     colordata.setcolor(true);

//     return () => {
//       colordata.setcolor(false);
//     };
//   }, []);

//   function getCurrentTimeByTimezone(dateObj, timeStr) {
//     const timezone = TorontoTimeZone;

//     const selectedDateStart = DateTime.fromJSDate(dateObj, {
//       zone: timezone,
//     }).startOf("day");

//     const combinedDateTime = DateTime.fromFormat(
//       `${timeStr} ${selectedDateStart.toFormat("EEE, LLL dd, yyyy")}`,
//       "HH:mm EEE, LLL dd, yyyy",
//       { zone: timezone }
//     );

//     return combinedDateTime.hasSame(selectedDateStart, "day");
//   }

//   let render = false;

//   return (
//     <>
//       <section className="predateSection">
//         <div className="cust_container">
//           <BookAppImmi />
//           <div className="row">
//             <div className="col-12">
//               <p className="slYuHead">Select your preferred date and time</p>

//               {/* calender */}
//               <div className="selectClndrDiv">
//                 <Calendar
//                   onChange={handleDateChange}
//                   value={dateTime?.date}
//                   tileDisabled={tileDisabled}
//                   tileClassName={tileClassName}
//                 />
//               </div>

//               {/*available on  */}
//               <div className="aviYouDiv">
//                 <p className="aviMonHead">Available on {onChangeDate}</p>
//                 <div
//                   className="d-flex align-items-center"
//                   style={{ flexWrap: "wrap" }}
//                 >
//                   <p
//                     className="youCnSchl blink-text"
//                     style={{ fontWeight: "700" }}
//                   >
//                     You can schedule an appointment between 2 hour and 14 days
//                     ahead of time. Time zone:{" "}
//                     <i
//                       style={{ fontSize: "16px", color: "red" }}
//                       class="fa-solid fa-arrow-right"
//                     ></i>{" "}
//                   </p>
//                   <form>
//                     <div className="form-group">
//                       <select
//                         className="form-control"
//                         value={TorontoTimeZone}
//                         onChange={(e) => setTorontoTimeZone(e.target.value)}
//                         style={{ paddingLeft: "5px" }}
//                       >
//                         {validTimezones?.map((timezone, index) => (
//                           <option key={index} value={timezone}>
//                             {timezone}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </form>
//                 </div>
//               </div>

//               {/* time list */}
//               {fetchTimeLoading ? (
//                 <div>
//                   <Spinner />
//                 </div>
//               ) : (
//                 !tileDisabled({ date: new Date(onChangeDate) }) &&
//                 moment(onChangeDate).day() !== 0 && (
//                   <div className="timeScheduleDiv">
//                     <div className="sevTimeAmDiv" style={{ cursor: "pointer" }}>
//                       {allTime.map((item, index) => {
//                         const dateObj = new Date(onChangeDate);

//                         const formattedDate = dateObj.toLocaleDateString(
//                           "en-US",
//                           {
//                             weekday: "short",
//                             month: "short",
//                             day: "2-digit",
//                             year: "numeric",
//                           }
//                         );

//                         const inputDT = item?.time + " " + formattedDate;
//                         const torontoTime = DateTime.fromFormat(
//                           inputDT,
//                           "HH:mm EEE, LLL dd, yyyy",
//                           { zone: "America/Toronto" }
//                         );
//                         const localTime = torontoTime.setZone(TorontoTimeZone);

//                         return (
//                           <>
//                             {/* Only show slot if ALL three parameters are false */}
//                             {isSlotAvailable(item) &&
//                               getCurrentTimeByTimezone(
//                                 selectedDate,
//                                 localTime.toFormat("HH:mm")
//                               ) && (
//                                 <>
//                                   {(render = true)}
//                                   <div
//                                     key={index}
//                                     className={`sevTimeAm ${
//                                       isSlotBlocked(item)
//                                         ? "sevTimeAmSelectColor"
//                                         : item.selected
//                                         ? "sevTimeAmSelectColor sevTimeAmColor"
//                                         : "sevTimeAmColor"
//                                     }`}
//                                     style={{
//                                       borderColor: item.selected
//                                         ? "green"
//                                         : null,
//                                     }}
//                                     onClick={() => {
//                                       setSearchSlotsForNextPageObject(
//                                         (prev) => ({ ...prev, index: index })
//                                       );
//                                       if (isSlotAvailable(item)) {
//                                         setAllTime((state) => {
//                                           let prevIndex = state.findIndex(
//                                             (it) => it.selected
//                                           );
//                                           if (prevIndex >= 0) {
//                                             state[prevIndex].selected = false;
//                                           }
//                                           state[index].selected = true;

//                                           return JSON.parse(
//                                             JSON.stringify(state)
//                                           );
//                                         });
//                                         setDateTime({
//                                           ...dateTime,
//                                           time: item._id,
//                                         });
//                                       }
//                                     }}
//                                   >
//                                     {item.selected ? (
//                                       <i class="fa-solid fa-check"></i>
//                                     ) : null}
//                                     <span
//                                       style={{}}
//                                       className={"sevTimeAmSelectColor"}
//                                     >
//                                       {" "}
//                                       <span
//                                         style={{
//                                           margin: "5px",
//                                           padding: "5px",
//                                           cursor: "pointer",
//                                           color:
//                                             isSlotAvailable(item) &&
//                                             !item.selected
//                                               ? "#fff"
//                                               : null,
//                                         }}
//                                       >
//                                         {localTime.toFormat("HH:mm")}
//                                       </span>
//                                     </span>{" "}
//                                   </div>
//                                 </>
//                               )}
//                           </>
//                         );
//                       })}
//                     </div>
//                     {!render && dateTime?.date && (
//                       <div
//                         style={{
//                           color: "red",
//                           textAlign: "center",
//                           fontSize: "32px",
//                           fontWeight: "600",
//                         }}
//                       >
//                         No slot found, Please select another Date
//                       </div>
//                     )}
//                     {!dateTime?.date && (
//                       <div
//                         style={{
//                           color: "red",
//                           textAlign: "center",
//                           fontSize: "32px",
//                           fontWeight: "600",
//                         }}
//                       >
//                         Please Select a Date
//                       </div>
//                     )}
//                   </div>
//                 )
//               )}

//               <div className="serMDiv">
//                 <p className="sevMorHead">
//                   Don't see your preferred date or time?
//                 </p>
//                 <div>
//                   <button
//                     onClick={() => {
//                       console.log("date", dateTime);
//                       navigate("/joinwaitlist", { state: dateTime });
//                     }}
//                     style={{ border: "none" }}
//                     className="joinWaitLink"
//                   >
//                     Join waitlist
//                   </button>
//                   <button
//                     onClick={onSUbmit}
//                     style={{ border: "none" }}
//                     className="joinWaitLink m-2"
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <BackPageBtn backLink="/bookappointment" />
//         </div>
//       </section>

//       {modalA && <SelectTimeZone closeTimeZoneModal={setModalA} />}
//     </>
//   );
// };

// export default PreferDateTime;

// in the above code join waitlist is not working
// -----------------------------------------------------------------------------------------------------------------------------

import {
  React,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import moment from "moment-timezone";
import "./BookAppointment.css";
import BookAppImmi from "../../Component/BookAppointment/BookAppImmi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import SelectTimeZone from "../../Component/Modal/SelectTimeZone";
import BackPageBtn from "./BackPageBtn";
import toast from "react-hot-toast";
import HomeServices from "../../Services/HomeServices";
import { Colorcontext } from "../../Component/context/ColorContext";
import { validTimezones } from "./TimeZone";
import { DateTime } from "luxon";
import { fetchTimeByDate } from "../../utils/HttpClientXml";
import Spinner from "./../../Spinner/Spinner";

const PreferDateTime = () => {
  const colordata = useContext(Colorcontext);

  let newDate = new Date();
  const formData = JSON.parse(localStorage.getItem("formData"));
  const [TorontoTimeZone, setTorontoTimeZone] = useState("America/Toronto");
  const currentDateTimeToronto = moment.tz(TorontoTimeZone);
  const [timeBlock, setTimeBlock] = useState(false);
  const myTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [searchSlotsForNextPageObject, setSearchSlotsForNextPageObject] =
    useState({});

  const [fetchTimeLoading, setFetchTimeLoading] = useState(false);

  const dateTimeField = {
    date: "",
    time: "",
    value: formData,
  };

  const [viewBlockdate, setViewBlockdate] = useState([]);
  const [allTime, setAllTime] = useState([]);
  const [dateTime, setDateTime] = useState(dateTimeField);
  const [modalA, setModalA] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [onChangeDate, setOnChangeDate] = useState("");

  const location = useLocation();
  console.log("ID", location?.state?._id);
  const navigate = useNavigate();

  const tileClassName = ({ date, view }) => {
    if (
      selectedDate &&
      date.getDate() === selectedDate.getDate() &&
      date.getMonth() === selectedDate.getMonth() &&
      date.getFullYear() === selectedDate.getFullYear()
    ) {
      return "active-date";
    }
    if (
      view === "month" &&
      date.getDate() === new Date().getDate() &&
      date.getMonth() === new Date().getMonth() &&
      date.getFullYear() === new Date().getFullYear()
    ) {
      return "current-date";
    }
    return null;
  };

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    GetAllDate(moment().tz(TorontoTimeZone).format("YYYY-MM-DD"));
    fetchViewBlockDate();
  }, [TorontoTimeZone, onChangeDate]);

  const GetAllDate = async (date) => {
    const date1 = new Date(onChangeDate);

    const year = date1.getFullYear();
    const month = String(date1.getMonth() + 1).padStart(2, "0");
    const day = String(date1.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;

    let data = {
      booking_serviceType_id: location?.state?._id,
      date: formattedDate,
      timezone: TorontoTimeZone,
    };

    setSearchSlotsForNextPageObject({ ...data });

    setFetchTimeLoading(true);

    const startTime = Date.now();
    console.log("Hello", data);
    try {
      const res = await fetchTimeByDate(data);

      const elapsedTime = Date.now() - startTime;
      const remainingTime = 3000 - elapsedTime;

      if (res && res.status) {
        console.log("Amit All Time", res?.data);
        setAllTime(res?.data);
        setTimeBlock(res?.allTimeBlock);
      }

      if (remainingTime > 0) {
        setTimeout(() => {
          setFetchTimeLoading(false);
        }, remainingTime);
      } else {
        setFetchTimeLoading(false);
      }
    } catch (error) {
      console.error("⛔ API failed:", error);

      const elapsedTime = Date.now() - startTime;
      const remainingTime = 3000 - elapsedTime;

      if (remainingTime > 0) {
        setTimeout(() => {
          setFetchTimeLoading(false);
        }, remainingTime);
      } else {
        setFetchTimeLoading(false);
      }
    }
  };

  const fetchViewBlockDate = async () => {
    const res = await HomeServices.viewBlockDate();
    if (res && res?.status) {
      setViewBlockdate(res?.data);
    }
  };

  const blockDate = (date) => {
    const formatdate = moment(date).tz(TorontoTimeZone).format("YYYY-MM-DD");
    const check = viewBlockdate.find((item) => item?.block_date === formatdate);
    if (check) {
      return false;
    } else {
      return false;
    }
  };

  const handleDateChange = async (date) => {
    setTorontoTimeZone("America/Toronto");
    const date1 = new Date(date);
    const year = date1.getFullYear();
    const month = String(date1.getMonth() + 1).padStart(2, "0");
    const day = String(date1.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;

    console.log("YTR117", formattedDate, date, TorontoTimeZone);

    const chDate = moment(date).format("ddd, MMM D, YYYY");
    setOnChangeDate(chDate);

    setDateTime({
      ...dateTime,
      date: date,
      time: "",
    });

    setSelectedDate(date);
  };

  const tileDisabled = ({ date }) => {
    let todayDay = moment(newDate).tz(TorontoTimeZone).format("YYYYMMDD");
    let selectedDate = moment(date).format("YYYYMMDD");

    const currentDate = new Date(
      moment(newDate).tz(TorontoTimeZone).format("YYYY-MM-DD")
    );
    currentDate.setHours(0, 0, 0, 0);
    const isPastDate = todayDay > selectedDate;

    const fourteenDaysAhead = new Date();
    fourteenDaysAhead.setDate(currentDate.getDate() + 14);
    fourteenDaysAhead.setHours(0, 0, 0, 0);
    const isDateBeyondFourteenDays = date > fourteenDaysAhead;

    const isSunday = date.getDay() === 0;

    const isBlocked = blockDate(date);

    return isPastDate || isDateBeyondFourteenDays || isSunday || isBlocked;
  };

  // Submit button validation - requires both date and time
  const onSUbmit = () => {
    if (!dateTime.date) {
      toast.error("Please select a date");
      return;
    }

    if (!dateTime.time) {
      toast.error("Please select a time");
      return;
    }

    if (
      moment(dateTime.date).format("YYYYMMDD") <
      moment(new Date()).format("YYYYMMDD")
    ) {
      toast.error("Cannot select past dates");
      return;
    }

    if (typeof dateTime.time === "string") {
      const fullDateTime = new Date(dateTime.date);
      const [hours, minutes] = dateTime.time.split(":");
      fullDateTime.setHours(parseInt(hours), parseInt(minutes));

      const navigationState = {
        dateTime: dateTime, // Send the original dateTime object format
        searchSlotsForNextPageObject: searchSlotsForNextPageObject,
        actualDate: moment(selectedDate).format("YYYY-MM-DD"),
      };

      console.log("Submit - Navigating with data:", navigationState);
      // console.log(
      //   "Submit - Navigating with data:",
      //   moment(selectedDate).format("YYYY-MM-DD")
      // );
      // return;
      navigate("/joinwaitlist", { state: navigationState });
    } else {
      toast.error("Invalid time format");
    }
  };

  // Join waitlist button - allows joining without time selection
  const handleJoinWaitlist = () => {
    if (!dateTime.date) {
      toast.error("Please select a date");
      return;
    }

    // For join waitlist, we don't require time selection
    const navigationState = {
      dateTime: dateTime, // Send the original dateTime object format
      searchSlotsForNextPageObject: searchSlotsForNextPageObject,
    };

    console.log("Join Waitlist - Navigating with data:", navigationState);
    navigate("/joinwaitlist", { state: navigationState });
  };

  // Modified function: Only show slot if ALL three parameters are false
  const isSlotAvailable = (item) => {
    return !item.isBooked && !item.isTimeOver && !item.isBlockedTime;
  };

  // Function to check if slot is blocked/selected for styling
  const isSlotBlocked = (item) => {
    return item.isBooked || item.isTimeOver || item.isBlockedTime;
  };

  useEffect(() => {
    colordata.setcolor(true);

    return () => {
      colordata.setcolor(false);
    };
  }, []);

  function getCurrentTimeByTimezone(dateObj, timeStr) {
    const timezone = TorontoTimeZone;

    const selectedDateStart = DateTime.fromJSDate(dateObj, {
      zone: timezone,
    }).startOf("day");

    const combinedDateTime = DateTime.fromFormat(
      `${timeStr} ${selectedDateStart.toFormat("EEE, LLL dd, yyyy")}`,
      "HH:mm EEE, LLL dd, yyyy",
      { zone: timezone }
    );

    return combinedDateTime.hasSame(selectedDateStart, "day");
  }

  let render = false;

  return (
    <>
      <section className="predateSection">
        <div className="cust_container">
          <BookAppImmi />
          <div className="row">
            <div className="col-12">
              <p className="slYuHead">Select your preferred date and time</p>

              {/* calender */}
              <div className="selectClndrDiv">
                <Calendar
                  onChange={handleDateChange}
                  value={dateTime?.date}
                  tileDisabled={tileDisabled}
                  tileClassName={tileClassName}
                />
              </div>

              {/*available on  */}
              <div className="aviYouDiv">
                <p className="aviMonHead">Available on {onChangeDate}</p>
                <div
                  className="d-flex align-items-center"
                  style={{ flexWrap: "wrap" }}
                >
                  <p
                    className="youCnSchl blink-text"
                    style={{ fontWeight: "700" }}
                  >
                    You can schedule an appointment between 2 hour and 14 days
                    ahead of time. Time zone:{" "}
                    <i
                      style={{ fontSize: "16px", color: "red" }}
                      className="fa-solid fa-arrow-right"
                    ></i>{" "}
                  </p>
                  <form>
                    <div className="form-group">
                      <select
                        className="form-control"
                        value={TorontoTimeZone}
                        onChange={(e) => setTorontoTimeZone(e.target.value)}
                        style={{ paddingLeft: "5px" }}
                      >
                        {validTimezones?.map((timezone, index) => (
                          <option key={index} value={timezone}>
                            {timezone}
                          </option>
                        ))}
                      </select>
                    </div>
                  </form>
                </div>
              </div>

              {/* time list */}
              {fetchTimeLoading ? (
                <div>
                  <Spinner />
                </div>
              ) : (
                !tileDisabled({ date: new Date(onChangeDate) }) &&
                moment(onChangeDate).day() !== 0 && (
                  <div className="timeScheduleDiv">
                    <div className="sevTimeAmDiv" style={{ cursor: "pointer" }}>
                      {allTime.map((item, index) => {
                        const dateObj = new Date(onChangeDate);

                        const formattedDate = dateObj.toLocaleDateString(
                          "en-US",
                          {
                            weekday: "short",
                            month: "short",
                            day: "2-digit",
                            year: "numeric",
                          }
                        );

                        const inputDT = item?.time + " " + formattedDate;
                        const torontoTime = DateTime.fromFormat(
                          inputDT,
                          "HH:mm EEE, LLL dd, yyyy",
                          { zone: "America/Toronto" }
                        );
                        const localTime = torontoTime.setZone(TorontoTimeZone);

                        return (
                          <>
                            {/* Only show slot if ALL three parameters are false */}
                            {isSlotAvailable(item) &&
                              getCurrentTimeByTimezone(
                                selectedDate,
                                localTime.toFormat("HH:mm")
                              ) && (
                                <>
                                  {(render = true)}
                                  <div
                                    key={index}
                                    className={`sevTimeAm ${
                                      isSlotBlocked(item)
                                        ? "sevTimeAmSelectColor"
                                        : item.selected
                                        ? "sevTimeAmSelectColor sevTimeAmColor"
                                        : "sevTimeAmColor"
                                    }`}
                                    style={{
                                      borderColor: item.selected
                                        ? "green"
                                        : null,
                                    }}
                                    onClick={() => {
                                      setSearchSlotsForNextPageObject(
                                        (prev) => ({ ...prev, index: index })
                                      );
                                      if (isSlotAvailable(item)) {
                                        setAllTime((state) => {
                                          let prevIndex = state.findIndex(
                                            (it) => it.selected
                                          );
                                          if (prevIndex >= 0) {
                                            state[prevIndex].selected = false;
                                          }
                                          state[index].selected = true;

                                          return JSON.parse(
                                            JSON.stringify(state)
                                          );
                                        });
                                        setDateTime({
                                          ...dateTime,
                                          time: item._id,
                                        });
                                      }
                                    }}
                                  >
                                    {item.selected ? (
                                      <i className="fa-solid fa-check"></i>
                                    ) : null}
                                    <span
                                      style={{}}
                                      className={"sevTimeAmSelectColor"}
                                    >
                                      {" "}
                                      <span
                                        style={{
                                          margin: "5px",
                                          padding: "5px",
                                          cursor: "pointer",
                                          color:
                                            isSlotAvailable(item) &&
                                            !item.selected
                                              ? "#fff"
                                              : null,
                                        }}
                                      >
                                        {localTime.toFormat("HH:mm")}
                                      </span>
                                    </span>{" "}
                                  </div>
                                </>
                              )}
                          </>
                        );
                      })}
                    </div>
                    {!render && dateTime?.date && (
                      <div
                        style={{
                          color: "red",
                          textAlign: "center",
                          fontSize: "32px",
                          fontWeight: "600",
                        }}
                      >
                        No slot found, Please select another Date
                      </div>
                    )}
                    {!dateTime?.date && (
                      <div
                        style={{
                          color: "red",
                          textAlign: "center",
                          fontSize: "32px",
                          fontWeight: "600",
                        }}
                      >
                        Please Select a Date
                      </div>
                    )}
                  </div>
                )
              )}

              <div className="serMDiv">
                {/* <p className="sevMorHead">
                  Don't see your preferred date or time?
                </p> */}
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <button
                    onClick={onSUbmit}
                    style={{ border: "none" }}
                    className="joinWaitLink m-2"
                  >
                    Submit
                  </button>
                  {/* <div>
                    <p className="sevMorHead">
                      Don't see your preferred date or time?
                    </p>
                    <button
                      onClick={handleJoinWaitlist}
                      style={{
                        border: "none",
                        height: "45px",
                        marginLeft: "100px",
                      }}
                      className="joinWaitLink"
                    >
                      Join waitlist
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <BackPageBtn backLink="/bookappointment" />
        </div>
      </section>

      {modalA && <SelectTimeZone closeTimeZoneModal={setModalA} />}
    </>
  );
};

export default PreferDateTime;
